import React from 'react';
import { Select, Space, Input } from 'udesk-ui';
import UdeskLocales from 'UdeskLocales';
interface ScoreRangeSelectProps {
    value?: [string, string, string];
    onChange?: (value: [string, string, string]) => void;
}

const ScoreRangeSelect: React.FC<ScoreRangeSelectProps> = ({ value = [], onChange }) => {
    const [scoreType, compareType, scoreValue] = value;

    const triggerChange = (newValue: Partial<[string, string, string]>) => {
        onChange?.([
            newValue[0] ?? scoreType,
            newValue[1] ?? compareType,
            newValue[2] ?? scoreValue,
        ] as [string, string, string]);
    };

    const handleScoreTypeChange = (newType: string) => {
        triggerChange([newType, undefined, undefined]);
    };

    const handleCompareTypeChange = (newCompare: string) => {
        triggerChange([scoreType, newCompare, undefined]);
    };

    const handleScoreValueChange = (e: React.ChangeEvent<HTMLInputElement>) => {
        triggerChange([scoreType, compareType, e.target.value]);
    };

    return (
        <Space>
            <Select
                style={{ width: 120 }}
                placeholder={/* 请选择 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.pleaseSelect}
                value={scoreType}
                onChange={handleScoreTypeChange}
                options={[
                    { label: /* 综合得分 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.comprehensiveScore, value: 'overall_score' },
                    { label: /* 课程质量 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.courseQuality, value: 'course_quality' },
                    { label: /* 学习效果 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.learningEffect, value: 'learning_effect' },
                    { label: /* 互动体验 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.interactiveExperience, value: 'interaction_experience' },
                ]}
            />
            <Select
                style={{ width: 120 }}
                placeholder={/* 请选择 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.pleaseSelect}
                value={compareType}
                onChange={handleCompareTypeChange}
                disabled={!scoreType}
                options={[
                    { label: /* 大于 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.greater, value: '>' },
                    { label: /* 等于 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.equal, value: '=' },
                    { label: /* 小于 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.less, value: '<' },
                ]}
            />
            <Input
                placeholder={/* 请输入 */UdeskLocales['current'].pages.coach.courseEvaluation.components.scoreRangeSelect.index.pleaseEnter}
                style={{ width: 120 }}
                type="number"
                value={scoreValue}
                onChange={handleScoreValueChange}
                disabled={!compareType}
            />
        </Space>
    );
};

export default ScoreRangeSelect;
